import type { RuleHandler } from "../types";

const checkMinimumOutcomeOdds: RuleHandler = (context, requirement) => {
  const minOutcomes = requirement.userDrivenAttributes?.minimumOutcomeOdds ?? 0;
  return context.selection.subOutcomes.every(
    (subOutcome) =>
      subOutcome.odds && minOutcomes && minOutcomes <= subOutcome.odds,
  );
};

export { checkMinimumOutcomeOdds };
